import React from "react";

import { Navigate, Outlet } from "react-router-dom";

import StorageService from "services/Storage";

import Template from "./Template/Template";

export default function ProtectedRoute() {
  const userToken = StorageService.getUserToken();

  if (!userToken) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Template>
      <Outlet />
    </Template>
  );
}
